/**
 * @fileoverview gRPC-Web generated client stub for proto
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v3.20.1
// source: proto/card_type.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.proto = require('./card_type_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.CardTypeServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.CardTypeServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.CreateCardTypeRequest,
 *   !proto.proto.CreateCardTypeResponse>}
 */
const methodDescriptor_CardTypeService_CreateCardType = new grpc.web.MethodDescriptor(
  '/proto.CardTypeService/CreateCardType',
  grpc.web.MethodType.UNARY,
  proto.proto.CreateCardTypeRequest,
  proto.proto.CreateCardTypeResponse,
  /**
   * @param {!proto.proto.CreateCardTypeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.CreateCardTypeResponse.deserializeBinary
);


/**
 * @param {!proto.proto.CreateCardTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.CreateCardTypeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.CreateCardTypeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CardTypeServiceClient.prototype.createCardType =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CardTypeService/CreateCardType',
      request,
      metadata || {},
      methodDescriptor_CardTypeService_CreateCardType,
      callback);
};


/**
 * @param {!proto.proto.CreateCardTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.CreateCardTypeResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CardTypeServicePromiseClient.prototype.createCardType =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CardTypeService/CreateCardType',
      request,
      metadata || {},
      methodDescriptor_CardTypeService_CreateCardType);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.UpdateCardTypeRequest,
 *   !proto.proto.UpdateCardTypeResponse>}
 */
const methodDescriptor_CardTypeService_UpdateCardType = new grpc.web.MethodDescriptor(
  '/proto.CardTypeService/UpdateCardType',
  grpc.web.MethodType.UNARY,
  proto.proto.UpdateCardTypeRequest,
  proto.proto.UpdateCardTypeResponse,
  /**
   * @param {!proto.proto.UpdateCardTypeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.UpdateCardTypeResponse.deserializeBinary
);


/**
 * @param {!proto.proto.UpdateCardTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.UpdateCardTypeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.UpdateCardTypeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CardTypeServiceClient.prototype.updateCardType =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CardTypeService/UpdateCardType',
      request,
      metadata || {},
      methodDescriptor_CardTypeService_UpdateCardType,
      callback);
};


/**
 * @param {!proto.proto.UpdateCardTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.UpdateCardTypeResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CardTypeServicePromiseClient.prototype.updateCardType =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CardTypeService/UpdateCardType',
      request,
      metadata || {},
      methodDescriptor_CardTypeService_UpdateCardType);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.DeleteCardTypeRequest,
 *   !proto.proto.DeleteCardTypeResponse>}
 */
const methodDescriptor_CardTypeService_DeleteCardType = new grpc.web.MethodDescriptor(
  '/proto.CardTypeService/DeleteCardType',
  grpc.web.MethodType.UNARY,
  proto.proto.DeleteCardTypeRequest,
  proto.proto.DeleteCardTypeResponse,
  /**
   * @param {!proto.proto.DeleteCardTypeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.DeleteCardTypeResponse.deserializeBinary
);


/**
 * @param {!proto.proto.DeleteCardTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.DeleteCardTypeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.DeleteCardTypeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CardTypeServiceClient.prototype.deleteCardType =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CardTypeService/DeleteCardType',
      request,
      metadata || {},
      methodDescriptor_CardTypeService_DeleteCardType,
      callback);
};


/**
 * @param {!proto.proto.DeleteCardTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.DeleteCardTypeResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CardTypeServicePromiseClient.prototype.deleteCardType =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CardTypeService/DeleteCardType',
      request,
      metadata || {},
      methodDescriptor_CardTypeService_DeleteCardType);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ListCardTypeRequest,
 *   !proto.proto.ListCardTypeResponse>}
 */
const methodDescriptor_CardTypeService_ListCardType = new grpc.web.MethodDescriptor(
  '/proto.CardTypeService/ListCardType',
  grpc.web.MethodType.UNARY,
  proto.proto.ListCardTypeRequest,
  proto.proto.ListCardTypeResponse,
  /**
   * @param {!proto.proto.ListCardTypeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ListCardTypeResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ListCardTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ListCardTypeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ListCardTypeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CardTypeServiceClient.prototype.listCardType =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CardTypeService/ListCardType',
      request,
      metadata || {},
      methodDescriptor_CardTypeService_ListCardType,
      callback);
};


/**
 * @param {!proto.proto.ListCardTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ListCardTypeResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CardTypeServicePromiseClient.prototype.listCardType =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CardTypeService/ListCardType',
      request,
      metadata || {},
      methodDescriptor_CardTypeService_ListCardType);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ItemCardTypeRequest,
 *   !proto.proto.ItemCardTypeResponse>}
 */
const methodDescriptor_CardTypeService_ItemCardType = new grpc.web.MethodDescriptor(
  '/proto.CardTypeService/ItemCardType',
  grpc.web.MethodType.UNARY,
  proto.proto.ItemCardTypeRequest,
  proto.proto.ItemCardTypeResponse,
  /**
   * @param {!proto.proto.ItemCardTypeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ItemCardTypeResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ItemCardTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ItemCardTypeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ItemCardTypeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CardTypeServiceClient.prototype.itemCardType =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CardTypeService/ItemCardType',
      request,
      metadata || {},
      methodDescriptor_CardTypeService_ItemCardType,
      callback);
};


/**
 * @param {!proto.proto.ItemCardTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ItemCardTypeResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CardTypeServicePromiseClient.prototype.itemCardType =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CardTypeService/ItemCardType',
      request,
      metadata || {},
      methodDescriptor_CardTypeService_ItemCardType);
};


module.exports = proto.proto;

